module.exports = __webpack_public_path__ + "img/ed90761.webp";